module.exports = __webpack_public_path__ + "img/goal-03.519537a4.png";